export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-GB": {
        "signUp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SIGN UP"])},
        "goToTests": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GO TO TESTS"])}
      },
      "nl-NL": {
        "signUp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["INSCHRIJVEN"])},
        "goToTests": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NAAR TESTEN"])}
      }
    }
  })
}
